import { ClientEnvironment } from '@polyai/common/constants/global.constants';

import api from 'api';
import type { IntegrationFormConfig } from './types';

const CXONE_ENVIRONMENTS = [
  'NA1',
  'EU1',
  'EU2',
  'AU1',
  'AU2',
  'CA1',
  'UK1',
  'UK2',
  'JP1',
  'KR1',
  'AE1',
  'JO1',
  'NA2',
  'ZA1',
];

export const niceMessagingHandoffFormConfig: IntegrationFormConfig = {
  onDisconnect: async (accountId, projectId, _recordId, queryClient) => {
    await api.deleteAllMessagingHandoffSecrets({
      accountId,
      projectId,
      provider: 'nice',
    });
    await queryClient?.invalidateQueries({
      queryKey: [accountId, projectId, 'messaging-handoff-secret', 'nice'],
    });
  },
  steps: [
    {
      title: 'Enter your NICE CXone details',
      description:
        'Provide your CXone Chat SDK channel ID, brand ID, and environment region.',
      schema: {
        type: 'object',
        properties: {
          ws_channel_id: {
            type: 'string',
            title: 'Chat Channel ID',
          },
          ws_brand_id: {
            type: 'string',
            title: 'Brand ID',
            pattern: '^[0-9]+$',
          },
          environment: {
            type: 'string',
            title: 'Environment',
            enum: CXONE_ENVIRONMENTS,
          },
        },
        required: ['ws_channel_id', 'ws_brand_id', 'environment'],
      },
      uiSchema: {
        ws_channel_id: {
          'ui:placeholder': 'chat_',
          'ui:requiredErrorMessage': 'Please supply the Chat Channel ID',
        },
        ws_brand_id: {
          'ui:requiredErrorMessage': 'Please supply the Brand ID',
          'ui:patternErrorMessage': 'Brand ID must be a numeric value',
        },
        environment: {
          'ui:requiredErrorMessage': 'Please select an environment',
        },
      },
      connectButtonLabel: 'Save credentials',
      onSubmit: async (accountId, projectId, data) => {
        const { ws_channel_id, ws_brand_id, environment } = data;

        const secretData = {
          ws_channel_id,
          ws_brand_id,
          environment,
        };

        for (const clientEnv of Object.values(ClientEnvironment)) {
          await api.upsertMessagingHandoffSecret({
            accountId,
            projectId,
            provider: 'nice',
            clientEnv,
            data: secretData,
          });
        }
      },
    },
  ],
};

export default niceMessagingHandoffFormConfig;
